import { mapEnum } from './mapEnum';
import { objects, constants } from '@breezeapp/breeze-schema';
import { ObjectOwnerType } from '@graphql/admin/generated/graphql.types';

type ObjectWithOwner = {
  owner?: typeof objects.objectOwner.objectOwner;
}

export const normalizeObjectOwner = <T extends ObjectWithOwner>(object: T) => {
  return {
    ...object,
    owner: object.owner ? {
      ...object.owner,
      objectOwnerType: mapEnum(constants.ObjectOwnerType, ObjectOwnerType, object.owner.objectOwnerType) ?? ObjectOwnerType.User
    } : object.owner,
  };
}